module.exports = __webpack_public_path__ + "img/cian.fd9d2fd3.png";